export default "__VITE_ASSET__CDqEBXQr__"